<template>
  <figure v-if="data.media" class="app-content-block-image">
    <div class="image-wrapper">
      <img class="image" loading="lazy" :src="data.media.url" :alt="data.media.alt" />
      <AppMediaCreditLine v-if="data.media.creditLine" :value="data.media.creditLine" />
    </div>
    <figcaption v-if="data.caption" class="caption">{{ data.caption }}</figcaption>
  </figure>
</template>

<script>
export default {
  components: {
    AppMediaCreditLine: () => import('@/components/AppMediaCreditLine.vue'),
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/assets/scss/variables-site/variables' as vars;

.app-content-block-image {
  @media (min-width: vars.$tablet-break-point) {
    margin: 16px 0;
  }

  .image-wrapper {
    position: relative;
    display: flex;
    width: max-content;
    max-width: 100%;
    margin: auto;
  }

  .image {
    max-width: 100%;
    height: auto;
    max-height: 600px;
  }

  .caption {
    margin-top: 14px;
    text-align: center;
    color: vars.$c-dark-5b;
  }
}
</style>
